<app-main-nav-bar></app-main-nav-bar>
<div class="page-wrapper bg-red p-t-180 p-b-100">
  <div class="wrapper wrapper--w960">
    <div class="card card-2">
      <div class="card-heading-health-family"></div>
      <div class="card-body">
        <h4 class="title">بیمه درمان گروهی</h4>
        <br>
        <p>
          یافتن بیمه درمان گروهی مطمئن کاری است که ما
          <br>
          به بهترین نحو برای شما انجام میدهیم.
        </p>
        <br>
        <br>
        <br>
        <br>
        <app-custom-button
          [HideMainButton]="false"
          [Show]="true"
          [LabelText]="'خرید بیمه'"
          [backUrl]="'/' + productName + '/requests'"
          [backButtonLabel]="'بیمه های من'"
          [BackButton]="true"
          (OnClick)="redirect()"></app-custom-button>
      </div>
    </div>
  </div>
</div>
